import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo y descripción */}
          <div className="lg:col-span-1">
            <div className="flex items-center mb-6 gap-2">
              <img 
                src="/assets/images/cdl_blanco.png" 
                alt="Logo CDL" 
                className="h-20 w-20 p-2"
              />
              <img 
                src="https://granacertification.org/wp-content/uploads/2022/07/logo-header.jpg" 
                alt="Logo GRANA" 
                className="h-16 w-auto p-2 bg-white rounded"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Certificación Internacional de Competencias y Habilidades para la Docencia en Línea - GRANA
            </p>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/certificacion" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Certificación
                </Link>
              </li>
              <li>
                <Link to="/acerca" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Acerca de GRANA
                </Link>
              </li>
              <li>
                <Link to="/recursos" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Recursos
                </Link>
              </li>
              <li>
                <Link to="/noticias" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  Noticias
                </Link>
              </li>
              <li>
                <a href="https://sievas.granacertification.org/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-orange-400 transition-colors duration-200 text-sm">
                  SIEVAS
                </a>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Servicios</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">Evaluación Docente</li>
              <li className="text-gray-300 text-sm">Certificación Internacional</li>
              <li className="text-gray-300 text-sm">Capacitación Digital</li>
              <li className="text-gray-300 text-sm">Consultoría Académica</li>
              <li className="text-gray-300 text-sm">Red Global de Educadores</li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contacto</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-orange-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">dvallin@certification-grana.org</p>
                  <p className="text-gray-300 text-sm">accreditationgrana@gmail.com</p>
                  <p className="text-gray-300 text-sm">donatovalllingonzalez@gmail.com</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-orange-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">USA: +1 (650) 690 2130</p>
                  <p className="text-gray-300 text-sm">México: +52 (317) 385 1203</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-orange-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-gray-300 text-sm">
                    2350 Alamo Ave, Suite 301<br/>
                    Albuquerque, NM, EEUU, 87106
                  </p>
                </div>
              </div>
            </div>

            {/* Botón CTA */}
            <div className="mt-6">
              <a
                href={
                  /Mobi|Android/i.test(navigator.userAgent)
                    ? "https://wa.me/+523173851203?text=Requiero informacion sobre el programa de certificación"
                    : "https://web.whatsapp.com/send?phone=+523173851203&text=Requiero informacion sobre el programa de certificación"
                }
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 bg-red-800 text-white text-sm font-medium rounded-md hover:bg-red-900 transition-colors duration-200"
              >
                Solicitar Certificación
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © 2025 Certificación Internacional para la Docencia en Línea - GRANA. 
                Todos los derechos reservados.
              </p>
            </div>
            <div className="mt-4 md:mt-0">
              <p className="text-gray-500 text-sm italic">
                Diseño y desarrollo: <span className="text-orange-400"><a href="https://programacioninteligente.com/" target='_blank' className="hover:burgundy"><i>Programación Inteligente.com</i></a></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;